import * as yup from "yup";

export const catalogValidationSchema = yup.object({
  designer: yup
    .string()
    .required("طراح کاتالوگ اجباری است")
    .min(3, "نام طراح باید حداقل ۳ کاراکتر باشد"),
  created_by: yup.string().required(),
  // index_picture: yup.string().nullable(),
  is_active: yup.boolean().required(),
  description: yup
    .string()
    .required("توضیحات اجباری است")
    .min(10, "توضیحات باید حداقل ۱۰ کاراکتر باشد"),
  // avatar: yup.mixed().nullable(),
  type: yup
    .mixed<"landscape" | "portrait">()
    .oneOf(["landscape", "portrait"])
    .required("جهت عکس را انتخاب کنید"),
});
